import { Injectable } from '@angular/core';
import LogRocket from 'logrocket';
import { ReplaySubject } from 'rxjs';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LogRocketService {
  private readonly readySubject$ = new ReplaySubject<string>(1);
  public readonly ready$ = this.readySubject$.asObservable();

  public userId = '';
  public userName = '';

  constructor() {
    if (environment.environmentName === 'dev') {
      this.readySubject$.next('DEV');
    } else {
      LogRocket.init(environment.logRocketAppId);
      LogRocket.getSessionURL((url) => {
        this.readySubject$.next(url);
      });
    }
  }

  public identify(id: string, name: string, costCenter: string): void {
    this.userName = name;
    this.userId = id;
    LogRocket.identify(id, { name, costCenter });
  }

  /**
   * @description Track custom actions that your users perform
   * @link https://docs.logrocket.com/reference/track
   * @example this.logRocketService.track('myEvent')
   * @example this.logRocketService.track('myEvent', {userId: 12345, product: 'pancakes', isLoggedIn: true})
   */
  public track(
    eventName: string,
    eventProperties?: Record<string, string | number | boolean | string[] | number[] | boolean[]>,
  ): void {
    LogRocket.track(eventName, eventProperties);
  }

  public get url(): string {
    if (environment.environmentName === 'dev') return '';
    return LogRocket.sessionURL ?? '';
  }
}
